:host {
  /**
   * @prop --c-tab-item-padding: Tab item padding
   */
  --_c-tab-item-padding: var(--c-tab-item-padding, 16px 0 0 0);

  display: block;
  min-width: 100%;
  user-select: none;
  
  > div {
    padding: var(--_c-tab-item-padding);
  }
}

:host([active='true']) {
  height: calc-size(auto, size);
  user-select: auto;
}

:host([active='false']) > div {
  display: none;
}

:host([disabled='true']) {
  min-width: 0;
  width: 0;
  overflow: hidden;
}
